import { extractLinkDataFromUrl } from '#features/guest-links';
import { appRoutes, isInTwoFactorAuthenticationLoginFlow } from '#services';
export const guestLoginRoutePredicate = ({ currentUser, location, }) => {
    if (isInTwoFactorAuthenticationLoginFlow(currentUser)) {
        return {
            isSuccess: false,
            navigateTo: appRoutes.login(),
        };
    }
    if (!currentUser) {
        return { isSuccess: true };
    }
    const locationState = location?.state;
    if (locationState?.navigatedFrom) {
        return {
            isSuccess: false,
            navigateTo: locationState.navigatedFrom,
        };
    }
    // In the case of the new guest link the user must be redirected to appropriate route
    // and not to /workspaces. Cases why the below block is needed - on logout
    // or browser refresh the navigatedFrom is cleared
    const { fullHash, pathname } = extractLinkDataFromUrl(location);
    const [, guestPath, guestLinkId] = pathname.split('/');
    if (guestPath === 'guest' && guestLinkId) {
        return {
            isSuccess: false,
            navigateTo: `/guest/${guestLinkId}${fullHash}`,
        };
    }
    return {
        isSuccess: false,
        navigateTo: '/workspaces',
    };
};
